// import { printHelp } from "../util";

export function ada(cmd) {
  // cmd.help();
  console.log(cmd);
  const flags = cmd.flags;

  console.dir("add command");
  // console.dir(flags);
}
